'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);


var _OptionTypeSwitcher = require('../OptionTypeSwitcher/OptionTypeSwitcher');var _OptionTypeSwitcher2 = _interopRequireDefault(_OptionTypeSwitcher);
var _components = require('../../../components');
var _PropertyCell = require('../../PropertyCell/PropertyCell');var _PropertyCell2 = _interopRequireDefault(_PropertyCell);


var _RealtorUser = require('../RealtorUser');
var _constants = require('../../../constants');




var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);


var _CompanyProperties = require('./CompanyProperties.scss');var styles = _interopRequireWildcard(_CompanyProperties);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// styles
var PROPERTIES_COUNT_TO_SHOW = { MOBILE: 10,
  DESKTOP: 18 };var


CompanyProperties = function (_Component) {_inherits(CompanyProperties, _Component);
  function CompanyProperties(props) {_classCallCheck(this, CompanyProperties);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.























    getContainerRef = function (ref) {_this.container = ref;};_this.

    getPropertiesInRowCount = function () {
      if (_this.props.isMobile) {return 1;}
      if (!_this.container) {return 3;}

      var containerWidth = _this.container.clientWidth;
      var propertyWidth = (0, _get2.default)(_this.container, 'children[0].children[0].clientWidth', 230);

      var scrollWidth = 15;
      var propertyMargin = 30;

      return Math.floor((containerWidth + scrollWidth) / (propertyWidth + propertyMargin));
    };_this.

    getPropertiesToShowCount = function () {
      if (_this.props.isMobile) {return PROPERTIES_COUNT_TO_SHOW.MOBILE;}
      if (!_this.container) {return PROPERTIES_COUNT_TO_SHOW.DESKTOP;}

      var rowsCount = 3;
      var countInRow = _this.getPropertiesInRowCount();

      return countInRow * rowsCount;
    };_this.

    setPropertiesInRowCount = function () {
      var count = _this.getPropertiesInRowCount();

      if (count !== _this.state.propertiesInRowCount) {
        var propertiesToShowCount = _this.getPropertiesToShowCount();
        _this.setState({
          propertiesInRowCount: count,
          propertiesToShowCount: propertiesToShowCount });

      }
    };_this.

    handleShowAll = function () {return _this.setState({ showAllProperties: true });};_this.

    handleSelectOption = function (evt) {
      evt.preventDefault();var
      value = evt.target.value;

      if (value !== _this.state.displayPropertiesFor) {
        _this.setState({ displayPropertiesFor: value });
      }
    };_this.

    handlePropertyClick = function (evt) {
      var id = (0, _get2.default)(evt, 'currentTarget.dataset.id');
      _this.props.openDetails(evt, id);
    };_this.

    mobilePropertyClickHandler = function (preloadData) {
      var pid = preloadData.propertyId;
      _this.props.openDetails({}, pid);
    };_this.

    renderSwitchTitle = function () {return (
        _react2.default.createElement(_OptionTypeSwitcher2.default, {
          translate: _this.props.translate('companyPage'),
          title: _this.props.translate('companyPage', 'properties').toString(),
          activeOption: _this.state.displayPropertiesFor,
          hasPropertiesForSale: _this.state.hasPropertiesForSale,
          hasPropertiesForRent: _this.state.hasPropertiesForRent,
          handleSelectOption: _this.handleSelectOption }));};_this.



    renderPropertyCell = function (property) {
      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(_this.props.locale);
      var address = englishAddressRequired ?
      property.address.en :
      property.address[_this.props.locale] || property.address[_constants.language.default];var


      id =








      property.id,thumbnail = property.thumbnail,price = property.price,property_type = property.property_type,search_option = property.search_option,_property$additional_ = property.additional_info;_property$additional_ = _property$additional_ === undefined ? {} : _property$additional_;var rooms = _property$additional_.rooms,parking = _property$additional_.parking,areaObject = _property$additional_.area,currency = property.currency;

      var isLand = property_type === 'land'; // temp patch
      var floor = isLand ? undefined : (0, _get2.default)(property, 'additional_info.floor.on_the');
      var roomsData = isLand ? undefined : rooms;

      var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';
      var addressString = address.street_name + ' ' + houseNumber;

      var propertyImage = thumbnail && (0, _modifyImageLink2.default)(thumbnail, _constants.imageModifierTypes.SLIDER_THUMBNAIL) || null;
      var area = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject;

      var commonProps = {
        neighborhood: address.neighborhood,
        key: id,
        locale: _this.props.locale,
        isMobile: _this.props.isMobile,
        isRtl: _this.props.isRtl,
        translate: _this.props.translate,
        id: id,
        photo: propertyImage,
        price: price,
        address: addressString,
        rooms: roomsData,
        parkingSpots: parking,
        city: address.city_name,
        area: area,
        floor: floor,
        propertyType: _this.props.translate('propertyTypes', property_type)(),
        isPromoted: property.is_promoted,
        hasVRLink: !!property.vr_link,
        searchOption: search_option,
        groundFloorTitle: _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut'),
        currency: currency };


      var style = {};

      if (!_this.props.isMobile) {
        style.width = 'calc((100% / ' + _this.state.propertiesInRowCount + ') - 30px)';
      }

      return _this.props.isMobile ?

      _react2.default.createElement(_PropertyCell2.default, _extends({},
      commonProps, {
        openDetailsPopup: _this.mobilePropertyClickHandler })) :



      _react2.default.createElement('div', { key: id, 'data-id': id, onClick: _this.handlePropertyClick, style: style },
        _react2.default.createElement(_components.OMBaseVerticalPropertyCell, _extends({},
        commonProps, {
          isHomePageSlider: true })));



    };_this.

    renderProperties = function () {
      var properties = _this.props[_this.state.displayPropertiesFor] || [];

      if (!_this.state.showAllProperties && properties.length > _this.state.propertiesToShowCount) {
        var countToShow = _this.state.propertiesToShowCount;
        properties = properties.slice(0, countToShow);
      }

      return properties.map(_this.renderPropertyCell);
    };_this.

    renderMoreButton = function () {
      var properties = _this.props[_this.state.displayPropertiesFor] || [];

      if (_this.state.showAllProperties || properties.length <= _this.state.propertiesToShowCount) {
        return null;
      }

      return (
        _react2.default.createElement('div', { className: styles.showMoreButton },
          _react2.default.createElement('button', {
              onClick: _this.handleShowAll },

            _this.props.translate('companyPage', 'showAllProperties'), ' ', _this.props.companyName)));



    };var hasPropertiesForSale = !!(0, _get2.default)(_this.props, [_RealtorUser.OPTION_TYPES_COMPANY.SALE, 'length']);var hasPropertiesForRent = !!(0, _get2.default)(_this.props, [_RealtorUser.OPTION_TYPES_COMPANY.RENT, 'length']);var propertiesOnlyForRent = !hasPropertiesForSale && hasPropertiesForRent;_this.state = { showAllProperties: false, propertiesInRowCount: props.isMobile ? 1 : 6, propertiesToShowCount: props.isMobile ? PROPERTIES_COUNT_TO_SHOW.MOBILE : PROPERTIES_COUNT_TO_SHOW.DESKTOP, hasPropertiesForSale: hasPropertiesForSale, hasPropertiesForRent: hasPropertiesForRent, displayPropertiesFor: propertiesOnlyForRent ? _RealtorUser.OPTION_TYPES_COMPANY.RENT : _RealtorUser.DEFAULT_DISPLAYED_PINS };return _this;}CompanyProperties.prototype.componentDidMount = function componentDidMount() {this.setPropertiesInRowCount();window.addEventListener('resize', this.setPropertiesInRowCount);};CompanyProperties.prototype.componentWillUnmount = function componentWillUnmount() {window.removeEventListener('resize', this.setPropertiesInRowCount);};CompanyProperties.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.propertiesContainer },
        this.renderSwitchTitle(),
        _react2.default.createElement('div', { className: styles.properties, ref: this.getContainerRef },
          this.renderProperties()),

        this.renderMoreButton()));


  };return CompanyProperties;}(_react.Component);


CompanyProperties.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  forSale: _propTypes2.default.array,
  forRent: _propTypes2.default.array,
  openDetails: _propTypes2.default.func,
  companyName: _propTypes2.default.string };exports.default =


CompanyProperties;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/CompanyProperties/CompanyProperties.js
// module id = 2888
// module chunks = 0